import React from "react";

import { extraIcons } from "../../utils/KindIcons";
import { Price } from "../../utils/types";

export const DynamicPricelistIcons = ({ icon }: { icon: string }) => {
    switch (icon) {
        case extraIcons.STRONGEST.emoji:
            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <span>🔥</span>
                    <span style={{ marginLeft: "-0.7vh" }}>🔥</span>
                    <span style={{ marginLeft: "-0.7vh" }}>🔥</span>
                </div>
            );
        case extraIcons.STRONGER.emoji:
            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <span>🔥</span>
                    <span style={{ marginLeft: "-0.7vh" }}>🔥</span>
                </div>
            );
        default:
            return <>{icon}</>;
    }
};

export const renderFlags = (flags?: string[]) => {
    return flags?.map((flag, index) => (
        <span key={`flag-${index}`} className="flagIcon">
            {flag}
        </span>
    ));
};

const renderIcons = (icons?: string[]) => {
    return icons?.map((icon, index) => (
        <span key={`icon-${index}`} className="strongIcon">
            <DynamicPricelistIcons icon={icon} />
        </span>
    ));
};

const renderPriceSuffix = (price?: Price) => {
    return price ? (
        <>
            {renderFlags(price.flags)}
            {renderIcons(price.icons)}
            {price.new && <span className="starIcon">⭐</span>}
        </>
    ) : null;
};

interface DynamicPricelistTextWithIconsProps {
    text: string;
    price: Price | null;
}

export const DynamicPricelistTextWithIcons = ({ text, price }: DynamicPricelistTextWithIconsProps) => {
    const words = text.split(" ");
    const lastWord = words.pop();
    const firstPart = words.join(" ");

    if (!price) return null;

    return (
        <p className="textWithIcons">
            {firstPart} {firstPart && " "}
            <span style={{ whiteSpace: "nowrap" }}>
                {lastWord}
                <span className="iconContainer">{renderPriceSuffix(price)}</span>
            </span>
        </p>
    );
};
